import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('IS.AssetMgmt.zoneList'),
      "headerBG": _vm.headerBG
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('niota-classic-common-account-filter', {
          attrs: {
            "initiallySelected": _vm.selectedAccounts.map(item => item.id),
            "multiple": ""
          },
          on: {
            "selected": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "reset-filter": _vm.resetFilter
          }
        })];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c(VRow, {
    staticClass: "py-0 my-0"
  }, [_c(VCol, {
    attrs: {
      "cols": "6",
      "sm": "4",
      "lg": "2"
    }
  }, [_c(VSelect, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.list.searchCategory'),
      "items": _vm.searchCategories,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.searchItem.category,
      callback: function ($$v) {
        _vm.$set(_vm.searchItem, "category", $$v);
      },
      expression: "searchItem.category"
    }
  })], 1), _c(VCol, [_vm.searchItem.category === 'tag' ? _c(VAutocomplete, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.categoryList,
      "hide-details": "",
      "clearable": "",
      "dense": ""
    },
    model: {
      value: _vm.searchItem.item,
      callback: function ($$v) {
        _vm.$set(_vm.searchItem, "item", $$v);
      },
      expression: "searchItem.item"
    }
  }) : _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "",
      "single-line": "",
      "clearable": "",
      "dense": ""
    },
    model: {
      value: _vm.searchItem.item,
      callback: function ($$v) {
        _vm.$set(_vm.searchItem, "item", $$v);
      },
      expression: "searchItem.item"
    }
  })], 1)], 1), _c(VDataTable, {
    attrs: {
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.localizedTableOptions.headers,
      "footer-props": _vm.localizedTableOptions.footerProps,
      "item-key": "id",
      "hide-default-header": ""
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (headerProps) {
        return [_c('thead', {
          staticClass: "v-data-table-header"
        }, [_c('tr', _vm._l(headerProps.props.headers, function (header) {
          return _c('th', {
            key: `asset_table_header_${header.value}`,
            class: _vm.detailTableHeaderColClass(header, headerProps.props)
          }, [header.value === 'id' ? [_vm._v(" ")] : header.value === 'category' ? [_vm._v(" ")] : header.value === 'title' ? [_c('span', {
            class: _vm.detailTableHeaderClasses(headerProps.props).text.title,
            on: {
              "click": function ($event) {
                return headerProps.on.sort(header.value);
              }
            }
          }, [_vm._v("\n                      " + _vm._s(header.text) + "\n                    ")]), _c(VIcon, {
            class: `${_vm.detailTableHeaderClasses(headerProps.props).icon.title}`,
            attrs: {
              "size": "18"
            }
          }, [_vm._v("\n                      fas fa-sort-up\n                    ")]), _vm._v("\n                    /\n                    "), _c('span', {
            class: _vm.detailTableHeaderClasses(headerProps.props).text.id,
            on: {
              "click": function ($event) {
                return headerProps.on.sort('id');
              }
            }
          }, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('Common.id')) + "\n                    ")]), _c(VIcon, {
            class: `${_vm.detailTableHeaderClasses(headerProps.props).icon.id}`,
            attrs: {
              "size": "18"
            }
          }, [_vm._v("\n                      fas fa-sort-up\n                    ")]), _vm._v("\n                    / (\n                    "), _c('span', {
            staticClass: "header-nonactive"
          }, [_vm._v(_vm._s(_vm.$i18n_t('IS.AssetMgmt.list.category')))]), _vm._v("\n                    )\n                  ")] : header.value === 'floorDtwin.title' ? [_c('span', {
            staticClass: "header-nonactive"
          }, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('IS.AssetMgmt.list.assetPosition')) + "\n                    ")]), _c('br'), _vm._v("\n                    (\n                    "), _c('span', {
            class: _vm.detailTableHeaderClasses(headerProps.props).text.floorDtwinTitle,
            on: {
              "click": function ($event) {
                return headerProps.on.sort(header.value);
              }
            }
          }, [_vm._v("\n                      " + _vm._s(header.text) + "\n                    ")]), _c(VIcon, {
            class: `${_vm.detailTableHeaderClasses(headerProps.props).icon.floorDtwinTitle}`,
            attrs: {
              "size": "18"
            }
          }, [_vm._v("\n                      fas fa-sort-up\n                    ")]), _vm._v("\n                    )\n                  ")] : [_c('span', {
            on: {
              "click": function ($event) {
                return headerProps.on.sort(header.value);
              }
            }
          }, [_vm._v(_vm._s(header.text))]), header.sortable ? _c(VIcon, {
            staticClass: "v-data-table-header__icon",
            attrs: {
              "size": "18"
            }
          }, [_vm._v("fas fa-sort-up")]) : _vm._e()]], 2);
        }), 0)])];
      }
    }, {
      key: "item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          staticClass: "px-0 text-center",
          staticStyle: {
            "width": "65px"
          },
          on: {
            "click": function ($event) {
              return _vm.handleRowClick(props.item);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "size": "16"
          }
        }, [_vm._v("fal fa-" + _vm._s(props.item.data.faIcon))])], 1), _c('td', {
          staticClass: "clickable",
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "250px"
          },
          attrs: {
            "colspan": "2"
          },
          on: {
            "click": function ($event) {
              return _vm.handleRowClick(props.item);
            }
          }
        }, [_c('span', {
          staticClass: "mx-2"
        }, [_c('router-link', {
          attrs: {
            "to": `/digitaltwin-mgmt/${props.item.id}`
          }
        }, [_vm._v("\n                    " + _vm._s(props.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(props.item.id) + ")\n                  ")]), _vm._v("\n                   \n                  "), _c('a', {
          attrs: {
            "href": `/#/digitaltwin-mgmt/${props.item.id}`,
            "target": "_blank"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "size": "12"
          }
        }, [_vm._v("fal fa-external-link")])], 1)], 1), _c('br'), _vm._l(props.item.data.tags, function (tag, i) {
          return _c(VChip, {
            key: `tag_${props.item.id}_${i}`,
            staticClass: "mx-1 my-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v("\n                  " + _vm._s(tag) + "\n                ")]);
        })], 2), _c('td', [(props.item.floorDtwin || {}).faIcon ? [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "size": "11"
          }
        }, [_vm._v("fal fa-" + _vm._s(props.item.floorDtwin.faIcon))]), _vm._v("\n                   \n                ")] : _vm._e(), _c('span', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(_vm._s((props.item.floorDtwin || {}).title))]), _c('span', {
          domProps: {
            "innerHTML": _vm._s(props.item.floorDtwin ? `<br />(${props.item.floorDtwin.number})` : '')
          }
        }), props.item.floorDtwinId ? [_vm._v("\n                   \n                  "), _c('a', {
          attrs: {
            "href": `/#/digitaltwin-mgmt/${props.item.floorDtwinId}`,
            "target": "_blank"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "size": "12"
          }
        }, [_vm._v("fal fa-external-link")])], 1)] : _vm._e()], 2), _c('td', {
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "150px"
          }
        }, [props.item.building ? [_c('router-link', {
          attrs: {
            "to": `/digitaltwin-mgmt/${props.item.building.id}`
          }
        }, [props.item.building.faIcon ? [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "size": "11"
          }
        }, [_vm._v("fal fa-" + _vm._s(props.item.building.faIcon))]), _vm._v("\n                       \n                    ")] : _vm._e(), _vm._v("\n                    " + _vm._s(props.item.building.title) + "\n                  ")], 2)] : _vm._e()], 2), _c('td', [props.item.trackables.length > 0 ? [_c(VTooltip, {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on,
              attrs
            }) {
              return [_c('span', _vm._g(_vm._b({}, 'span', attrs, false), on), [_vm._v(_vm._s(props.item.trackables.length))])];
            }
          }], null, true),
          model: {
            value: _vm.tooltips[props.item.id],
            callback: function ($$v) {
              _vm.$set(_vm.tooltips, props.item.id, $$v);
            },
            expression: "tooltips[props.item.id]"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, _vm._l(props.item.trackables, function (trackable, i) {
          return _c('p', {
            key: `trackable_${props.item.id}_${i}`,
            staticClass: "my-1 py-0"
          }, [_c('router-link', {
            attrs: {
              "to": `/digitaltwin-mgmt/${trackable.id}`
            }
          }, [_vm._v("\n                          " + _vm._s(trackable.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(trackable.id) + ")\n                        ")])], 1);
        }), 0)]), _vm._v("\n                   \n                  "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.toggleTrackablesTooltip(props.item.id);
            }
          }
        }, [_vm._v("\n                    fal fa-info-circle\n                  ")])] : [_vm._v("0")]], 2), _c('td', {
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "170px"
          }
        }, [_vm._v("\n                " + _vm._s(props.item.hierarchyLevel > 1 ? props.item.hierarchyLevel : _vm.$i18n_t('DigitalTwin.DigitalTwin.list.rootItem')) + "\n                "), props.item.parent ? [_vm._v("\n                   \n                  "), _c('router-link', {
          attrs: {
            "to": `/digitaltwin-mgmt/${props.item.parent.id}`
          }
        }, [_c(VIcon, {
          attrs: {
            "size": "11"
          }
        }, [_vm._v("fal fa-folder-tree")]), _vm._v("\n                      " + _vm._s(props.item.parent.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(props.item.parent.id) + ")\n                  ")], 1)] : _vm._e()], 2), _c('td', {
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "120px"
          }
        }, [_vm._v("\n                " + _vm._s(props.item.tenant.name) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(props.item.tenant.id) + ")\n              ")]), _c('td', {
          staticClass: "text-center"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.viewDetails'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push(`/digitaltwin-mgmt/${props.item.id}`);
            }
          }
        }, [_vm._v("\n                  fal fa-eye\n                ")])], 1)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n                " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n              ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };